const env = process.env.NODE_ENV;

let envApiUrl = "http://localhost";

if (env === "production") {
  envApiUrl = `http://gr.woa.com`;
} else if (env === "development") {
  envApiUrl = `http://localhost111`;
}
// env = "MOA";
export const envTag = env;
export const apiUrl = envApiUrl;
export const appName = process.env.VUE_APP_NAME;
